module.exports = __webpack_public_path__ + "img/0.0ee75f59.png";